import { ApiVersion } from '@approvalmax/types';
import { routerHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { stringify } from 'query-string';
import { api } from 'services/api';
import { getApiUrl } from 'shared/data';
import { requestsApiPaths } from 'shared/data/webApp/v2';

interface GetAttachmentUrlParams {
    requestIntegrationCode: domain.IntegrationCode | null;
    attachmentId: string;
    companyId: string;
    requestId: string;
    billRequestId?: string;
}

interface GetBillPaymentBillAttachmentUrlParams {
    attachmentId: string;
    companyId: string;
    requestId: string;
    inline: boolean;
    currencyId?: string;
    accountId?: string;
    billRequestId?: string;
    payeeId?: string;
}

// Hack to hide PDF name in the PDF-viewer if the Title meta is empty.
const applyChromePreviewHack = (url: string) => (url.includes('?') ? url.replace('?', '/?') : `${url}/?`);

const getAttachmentUrlFromPath = (path: string, queryParams?: Record<string, any>, apiVersion: ApiVersion = 'v2') =>
    applyChromePreviewHack(`${getApiUrl({ apiVersion })}${path}?${queryParams ? stringify(queryParams) : ''}`);

export const getAttachmentUrl = ({
    requestIntegrationCode,
    attachmentId,
    companyId,
    requestId,
    billRequestId,
}: GetAttachmentUrlParams) => {
    if (billRequestId) {
        switch (requestIntegrationCode) {
            case domain.IntegrationCode.XeroAmaxPayBatchPayment:
                return getAttachmentUrlFromPath(
                    routerHelpers.pathToUrl(requestsApiPaths.batchPaymentAmaxPayXeroBillAttachment, {
                        attachmentId,
                        companyId,
                        batchPaymentRequestId: requestId,
                        billRequestId,
                    })
                );

            case domain.IntegrationCode.XeroAirwallexBatchPayment:
                return getAttachmentUrlFromPath(
                    routerHelpers.pathToUrl(requestsApiPaths.batchPaymentAirwallexXeroBillAttachment, {
                        attachmentId,
                        companyId,
                        batchPaymentRequestId: requestId,
                        billRequestId,
                    })
                );

            case domain.IntegrationCode.XeroBillBatchPayment:
                return getAttachmentUrlFromPath(
                    routerHelpers.pathToUrl(requestsApiPaths.batchPaymentXeroBillAttachment, {
                        attachmentId,
                        companyId,
                        batchPaymentRequestId: requestId,
                        billRequestId,
                    })
                );
        }
    }

    return applyChromePreviewHack(api.requests.urls.getAttachment({ attachmentId, companyId }));
};

export const getBillPaymentBillAttachmentUrl = ({
    attachmentId,
    companyId,
    requestId,
    billRequestId,
    accountId,
    currencyId,
    payeeId,
    inline,
}: GetBillPaymentBillAttachmentUrlParams) => {
    if (billRequestId && accountId && currencyId) {
        return getAttachmentUrlFromPath(
            routerHelpers.pathToUrl(requestsApiPaths.netSuiteBillPaymentBillAttachment, {
                attachmentId,
                companyId,
                billPaymentRequestId: requestId,
                lineRequestId: billRequestId,
            }),
            {
                currencyId,
                accountId,
                payeeId,
                inline,
            }
        );
    }

    return applyChromePreviewHack(api.requests.urls.getAttachment({ attachmentId, companyId }));
};
